import { preloadImage } from "@/utils/load"

// 使用 webpack 的 require.context 动态加载所有图片
// 递归查找 imgs 目录下的所有图片文件，排除 loading 目录
// @ts-expect-error - webpack require.context 在类型定义中可能不存在，但运行时可用
const imageContext = require.context("@/assets/imgs", true, /\.(png|jpg|jpeg|svg)$/i)

// 过滤掉 loading 目录下的文件
const imagePaths = imageContext.keys().filter((path: string) => !path.includes("/loading/") && !path.includes("/multi/"))

// 判断是否支持 avif
function isAvifSupported(): Promise<boolean> {
    return new Promise((resolve) => {
        const avif = new Image()
        avif.onload = () => {
            resolve(avif.width === 1)
        }
        avif.onerror = () => {
            resolve(false)
        }
        // 1x1 avif, 超小体积检测数据
        avif.src = 'data:image/avif;base64,AAAAIGZ0eXBhdmlmAAAAAGF2aWZtaWYxbWlhZk1BMUIAAAEcbWV0YQAAAAAAAABIaGRscgAAAAAAAAAAcGljdAAAAAAAAAAAAAAAAGNhdmlmIC0gaHR0cHM6Ly9naXRodWIuY29tL2xpbmstdS9jYXZpZgAAAAAeaWxvYwAAAAAEQAABAAEAAAAAAUQAAQAAABcAAAAqaWluZgEAAAAAAAABAAAAGmluZmUCAAAAAAEAAGF2MDFJbWFnZQAAAAAOcGl0bQAAAAAAAQAAAHJpcHJwAAAAUmlwY28AAAAQcGFzcAAAAAEAAAABAAAAFGlzcGUAAAAAAAAAAQAAAAEAAAAQcGl4aQAAAAADCAgIAAAAFmF2MUOBAAwACggYAAYICGgIIAAAABhpcG1hAAAAAAAAAAEAAQUBAoMDhAAAAB9tZGF0CggYAAYICGgIIBoFHiAAAEQiBACwDoA=';
    })
}

// 判断是否支持 webp
function isWebpSupported(): Promise<boolean> {
    return new Promise((resolve) => {
        const webp = new Image()
        webp.onload = () => {
            resolve(webp.width === 1)
        }
        webp.onerror = () => {
            resolve(false)
        }
        webp.src =
            "data:image/webp;base64,UklGRiQAAABXRUJQVlA4IBgAAAAwAQCdASoBAAEAAwA0JaQAA3AA/vuUAAA="
    })
}


// 将所有图片路径转换为预加载任务
export const tasks = [...imagePaths.map((path: string) => {
    const imagePath = imageContext(path) as string
    return async () => {
        await preloadImage(imagePath)
    }
}), (async () => {
    if (await isAvifSupported()) {
        console.log("avif supported")
        preloadImage(require("@/assets/imgs/multi/top_layer.avif"))
    }
    else if (await isWebpSupported()) {
        console.log("webp supported")
        preloadImage(require("@/assets/imgs/multi/top_layer.webp"))
    } else {
        console.log("png supported")
        preloadImage(require("@/assets/imgs/multi/top_layer.png"))
    }
})]
